/* global $, API */

/**
 * Request suggestions from the server
 * @param  {String}   query User input
 * @param  {Function} cb    Callback after the request has been succesfully finished
 * @return {Void}
 */
export default (query, cb) => {
  const url = API.searchAutocomplete;

  $.ajax({
    url: `${url}${query}`,
    dataType: 'json',
    success: (data) => {
      cb.call(this, data);
    },
  });
};
